/**
 * snapshotdetailsactions.js
 * Created by zl52fc on 11/17/2020.
 */
import queryString from 'query-string';
import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL, aresTaskViewRoutes} from '../../util/uiconstants';
import _ from 'lodash';

export function getSnapshotById(engagementId, documentId, snapshotId, sourceSnapshotId, isPrintView, isAresPrintView) {
	let url = `${env.getBaseURL(serviceURL, engagementId)}Forms/${documentId}/Snapshots/${snapshotId}`;

	let urlParams = {};

	if (sourceSnapshotId !== undefined && sourceSnapshotId !== null) {
		urlParams.sourceSnapshotId = sourceSnapshotId;
	}

	if (isPrintView === true) {
		urlParams.isPrintView = true;
	}

	if (isAresPrintView === true) {
		urlParams.documentType = aresTaskViewRoutes.guidedworkflow;
	}

	if (!_.isEmpty(urlParams)) {
		url += '?' + queryString.stringify(urlParams);
	}

	if (sourceSnapshotId === null || sourceSnapshotId === undefined) {
		return {
			type: types.GET_SNAPSHOT_BY_ID,
			documentId,
			isPrintView,
			meta: {
				api: {
					url,
					method: 'GET'
				}
			}
		};
	}

	return {
		type: types.GET_SNAPSHOT_COMPARE_BY_ID,
		documentId,
		isPrintView,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
}

export const clearSnapshotCompareView = (isClearView) => {
	return {
		type: types.CLEAR_SNAPSHOT_COMPARE_VIEW,
		response: isClearView
	};
};

export const clearRightSideSnapshotView = (isClearView) => {
	return {
		type: types.CLEAR_RIGHT_SIDE_SNAPSHOT_VIEW,
		response: isClearView
	};
};

export const showHideRightSideSnapshotView = (isHideView) => {
	return {
		type: types.SHOW_HIDE_RIGHT_SIDE_SNAPSHOT_VIEW,
		response: isHideView
	};
};

export const showHideLeftSideSnapshotView = (isHideView) => {
	return {
		type: types.SHOW_HIDE_LEFT_SIDE_SNAPSHOT_VIEW,
		response: isHideView
	};
};
